import { Controller } from "@hotwired/stimulus"

// Opens the packet-pickup "Add Note" <dialog>. The trigger is an <a> that also
// drives the note_modal_content Turbo Frame, so the open still needs a line of
// JS -- command="show-modal" is button-only and cannot ride on the frame link.
//
// Closing is native (command="close" on the buttons, closedby="any" on the
// dialog). Focusing the textarea is native too: Turbo focuses the [autofocus]
// field once the frame (or the error turbo-stream) renders.
export default class extends Controller {
  open(): void {
    const dialog = document.getElementById("noteModal") as HTMLDialogElement | null
    dialog?.showModal()
  }
}
